import { WAITLIST_URL, scrollToId } from "./data";

export const Mark = ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
        <path
            d="M12 3v18M3 12h18M5.6 5.6l12.8 12.8M18.4 5.6L5.6 18.4"
            stroke="#C7B7FF"
            strokeWidth="2.2"
            strokeLinecap="round"
        />
    </svg>
);

export const Nav = () => (
    <header
        data-testid="header-navigation"
        className="fixed top-0 left-0 right-0 z-50 border-b border-[#262422] bg-[#0D0C0B]/85 backdrop-blur-md"
    >
        <div className="mx-auto flex max-w-[1500px] items-center justify-between px-5 py-4 sm:px-8">
            <a
                href="#top"
                data-testid="nav-brand-link"
                onClick={(e) => scrollToId(e, "#top")}
                className="flex items-center gap-2.5"
            >
                <Mark />
                <span className="text-sm font-semibold tracking-tight text-[#F4F1EC]">
                    DiscoveryProject
                </span>
            </a>
            <nav className="flex items-center gap-6 sm:gap-8" aria-label="Primary">
                <a
                    href="#how-it-works"
                    data-testid="nav-link-how-it-works"
                    onClick={(e) => scrollToId(e, "#how-it-works")}
                    className="nav-link hidden text-sm text-[#C9C5C0] hover:text-[#F4F1EC] md:block"
                >
                    How it works
                </a>
                <a
                    href="#principles"
                    data-testid="nav-link-principles"
                    onClick={(e) => scrollToId(e, "#principles")}
                    className="nav-link hidden text-sm text-[#C9C5C0] hover:text-[#F4F1EC] md:block"
                >
                    Principles
                </a>
                <a
                    href={WAITLIST_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="nav-cta-waitlist"
                    className="cta-primary rounded-full bg-[#C7B7FF] px-4 py-2 text-sm font-semibold text-[#0D0C0B] sm:px-5"
                >
                    Join waitlist
                </a>
            </nav>
        </div>
    </header>
);
